import * as React from "react";

const Cookies = require("universal-cookie");
const cookies = new Cookies();

interface IProps {}
interface IState {
  isVisible: Boolean;
}

class CookieComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    if (cookies.get("cookie-mesg-shown") === "true") {
      this.state = { isVisible: false };
    } else {
      this.state = { isVisible: true };
    }
  }

  crossClicked = () => {
    cookies.set("cookie-mesg-shown", "true", { path: "/" });
    this.setState({
      isVisible: false
    });
  };

  addClasses = () => {
    return "cookie-component " + (this.state.isVisible === true ? "" : "hide");
  };

  render(): JSX.Element {
    return (
      <div className={this.addClasses()}>
        <p>
          This website used cookies to make your browsing experience better. By
          using this site you agree that we use these cookies. See our{" "}
          <a href="/privacypolicy">Privacy Policy</a>
        </p>
        <div onClick={this.crossClicked} className="cross-icon">
          <span />
          <span />
        </div>
      </div>
    );
  }
}

export default CookieComponent;



// WEBPACK FOOTER //
// ./src/components/cookie.component.tsx